export class PredictionDateDialog {
  static $inject = ['$mdDialog'];

  predictionDate:Date;

  constructor(private $mdDialog:ng.material.IDialogService) {
    this.predictionDate = new Date();
  }

  apply = () => {
    this.$mdDialog.hide(this.predictionDate);
  };

  cancel = () => {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/forecast-model/prediction-date-dialog.controller.ts
 **/